import { defineStore } from 'pinia'

interface State {
  downloading: ExportFile[],
}

export const useExportFileStore = defineStore('ExportFile', {
  state: (): State => ({
    downloading: [],
  }),
  actions: {
    addDownloading (exportFile: ExportFile) {
      this.downloading.push(exportFile)
    },
    removeDownloading (exportFileId: number) {
      this.downloading = this.downloading.filter(file => file.id !== exportFileId)
    },
    markAsFailed (e: { export_file_id: number, fail_reason: string }) {
      const file = this.downloading.find(file => file.id === e.export_file_id)
      if (file) {
        file.fail_reason = e.fail_reason
      }
    },
  },
})
